// extracted by mini-css-extract-plugin
export default {"main":"login_main__04ebx"};